import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=6b5fac40&"
import script from "./CommentHistory.vue?vue&type=script&lang=js&"
export * from "./CommentHistory.vue?vue&type=script&lang=js&"
import style0 from "./CommentHistory.vue?vue&type=style&index=0&id=6b5fac40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports